import React from 'react'
import Pc from './pc/index'
import Mob from './mob/index'
import Media from 'COMPONENTS/Media'

const About = () => {
  return (
    <>
      <Media platform="pc">
        <Pc />
      </Media>
      <Media platform="mobile">
        <Mob />
      </Media>
    </>
  )
}

export default About
